export const detectGgFromConfirmation = () => {

  if (typeof jQuery === 'undefined') {
    return;
  }
  
  jQuery(document).on('gform_confirmation_loaded', function() {
    const container = document.querySelector('.assecolp-form-wrapper');
    
    if (!container) {
      return;
    }
    container.style.zIndex = '0';
  });
}
